var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Delete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    opacity: 0.4,
    d: "M21.5542 9.86008C21.5542 9.94508 20.888 18.371 20.5075 21.9172C20.2692 24.0933 18.8663 25.4133 16.762 25.4508C15.1451 25.487 13.5623 25.4995 12.005 25.4995C10.3516 25.4995 8.73475 25.487 7.1653 25.4508C5.13145 25.402 3.72732 24.0558 3.5012 21.9172C3.10975 18.3585 2.45571 9.94508 2.44355 9.86008C2.4314 9.60384 2.51406 9.3601 2.68183 9.16261C2.84716 8.98011 3.08544 8.87012 3.33587 8.87012H20.674C20.9233 8.87012 21.1494 8.98011 21.3281 9.16261C21.4946 9.3601 21.5785 9.60384 21.5542 9.86008Z",
    fill: "#DB5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M23.25 5.47108C23.25 4.95734 22.8452 4.55486 22.3589 4.55486H18.7143C17.9727 4.55486 17.3284 4.02738 17.163 3.28365L16.9588 2.37243C16.6731 1.27122 15.6872 0.5 14.5809 0.5H9.42031C8.30187 0.5 7.32567 1.27122 7.02904 2.43243L6.83818 3.2849C6.67163 4.02738 6.02731 4.55486 5.28696 4.55486H1.64232C1.15482 4.55486 0.75 4.95734 0.75 5.47108V5.94606C0.75 6.44729 1.15482 6.86228 1.64232 6.86228H22.3589C22.8452 6.86228 23.25 6.44729 23.25 5.94606V5.47108Z",
    fill: "#DB5F5F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d21f1b9ec30df9e873807f3dbcd3bb57.svg";
export { ForwardRef as ReactComponent };